<form #blockInputs="ngForm">
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LAYOUT.TEXT' | translate }}</glxy-label>
    <select matInput [(ngModel)]="content.layout" name="Image Style">
      <option value="LargeVertical">{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LAYOUT.VERTICAL' | translate }}</option>
      <option value="largeHorizontal">
        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LAYOUT.HORIZONTAL_LARGE' | translate }}
      </option>
      <option value="mediumHorizontal">
        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LAYOUT.HORIZONTAL_MEDIUM' | translate }}
      </option>
      <option value="smallHorizontal">
        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LAYOUT.HORIZONTAL_SMALL' | translate }}
      </option>
    </select>
  </glxy-form-field>

  <div class="item-list" cdkDropList (cdkDropListDropped)="drop($event)">
    @if (content.items.length === 0) {
      <div class="no-items-message">
        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.ADD_NEW_BUTTON_1' | translate }}
        {{ content.layout === 'LargeVertical' ? 'column' : 'row' }}
        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.ADD_NEW_BUTTON_2' | translate }}
        <div class="no-items-arrow">
          <mat-icon [inline]="true">arrow_downward</mat-icon>
        </div>
      </div>
    }

    @for (
      item of content.items;
      track fixFieldLosingFocusWhenTyping(i, item);
      let i = $index;
      let first = $first;
      let last = $last
    ) {
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="addNewAbove(i)">
          <mat-icon>add</mat-icon>
          {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.ADD_ABOVE' | translate }}
        </button>
        <button mat-menu-item (click)="duplicateItem(i)">
          <mat-icon>content_copy</mat-icon>
          {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.DUPLICATE' | translate }}
        </button>
        <mat-divider />
        @if (!item.collapsed) {
          <button mat-menu-item (click)="item.collapsed = true">
            <mat-icon>unfold_less</mat-icon>
            <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.COLLAPSE' | translate }}</span>
          </button>
        }
        @if (item.collapsed) {
          <button mat-menu-item (click)="item.collapsed = false">
            <mat-icon>unfold_more</mat-icon>
            <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.EXPAND' | translate }}</span>
          </button>
        }
        <button mat-menu-item [matMenuTriggerFor]="blockOrderMenu">
          <mat-icon>swap_vert</mat-icon>
          <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.ORDER' | translate }}</span>
        </button>
        <mat-divider />
        <button mat-menu-item (click)="removeItem(i)">
          <mat-icon>clear</mat-icon>
          {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.REMOVE' | translate }}
        </button>
      </mat-menu>
      <mat-menu #blockOrderMenu="matMenu">
        <button mat-menu-item [disabled]="first" (click)="moveBlockToTop(i)">
          <mat-icon>vertical_align_top</mat-icon>
          <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.MOVE_TO_TOP' | translate }}</span>
        </button>
        <button mat-menu-item [disabled]="first" (click)="moveBlock(i, -1)">
          <mat-icon>arrow_upward</mat-icon>
          <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.MOVE_UP' | translate }}</span>
        </button>
        <button mat-menu-item [disabled]="last" (click)="moveBlock(i, 1)">
          <mat-icon>arrow_downward</mat-icon>
          <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.MOVE_DOWN' | translate }}</span>
        </button>
        <button mat-menu-item [disabled]="last" (click)="moveBlockToBottom(i)">
          <mat-icon>vertical_align_bottom</mat-icon>
          <span>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.MOVE_TO_BOTTOM' | translate }}</span>
        </button>
      </mat-menu>
      <div class="item" cdkDrag>
        <div
          class="toolbar"
          cdkDragHandle
          (dblclick)="item.collapsed = !item.collapsed"
          [class.collapsed]="item.collapsed"
        >
          <mat-icon class="drag-icon">drag_indicator</mat-icon>
          <div class="summary-text">
            @if (item.collapsed) {
              <div
                class="image-preview small"
                [style.backgroundImage]="item.imageUrl ? 'url(' + item.imageUrl + ')' : null"
              ></div>
              <strong>{{ item.heading }}</strong>
              {{ item.subheading }}
              {{ item.body }}
            }
          </div>
          <!-- Using a switch case so it opens and closes without a delay -->
          @switch (item.collapsed) {
            @case (true) {
              <button
                mat-icon-button
                (click)="item.collapsed = false"
                matTooltip=" {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.TIPS.EXPAND' | translate }} "
              >
                <mat-icon>unfold_less</mat-icon>
              </button>
            }
            @case (false) {
              <button
                mat-icon-button
                (click)="item.collapsed = true"
                matTooltip=" {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.TIPS.COLLAPSE' | translate }} "
              >
                <mat-icon>unfold_more</mat-icon>
              </button>
            }
          }
          <button type="button" mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            (click)="removeItem(i)"
            matTooltip=" {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.TIPS.REMOVE' | translate }} "
          >
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        @if (!item.collapsed) {
          <div class="form-grid-layout">
            @if (item.imageUrl) {
              <glxy-form-field horizontalLayout="true">
                <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.IMAGE' | translate }}</glxy-label>
                <div class="image-upload-wrapper">
                  <div class="image-preview" [style.backgroundImage]="'url(' + item.imageUrl + ')'"></div>
                  <div class="image-controls">
                    <glxy-button-group>
                      <a mat-stroked-button [href]="item.imageUrl" target="_blank" rel="noopener">View</a>
                      <button mat-stroked-button type="button" (click)="clearImage(i)">
                        {{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.CLEAR' | translate }}
                      </button>
                    </glxy-button-group>
                  </div>
                </div>
              </glxy-form-field>
            } @else {
              <glxy-form-field horizontalLayout="true">
                <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.IMAGE' | translate }}</glxy-label>
                <div class="image-upload-buttons">
                  <glxy-image-uploader
                    #imageUploader
                    [layout]="'button-only'"
                    [autoUpload]="true"
                    [maxFiles]="1"
                    [hintText]="'ADD_SOMETHING_HINT' | translate"
                    (fileUploaded)="setImage($event, i)"
                    (fileUploadErrored)="alertFileErrored($event)"
                  />
                  <button
                    class="image-buttons"
                    mat-icon-button
                    (click)="openSuggestImageDialog(i)"
                    [glxyTooltip]="'EMAIL_BUILDER.CONTENT_SUGGESTION.GENERATE_IMAGE' | translate"
                  >
                    <mat-icon svgIcon="galaxy-ai-icon" />
                  </button>
                </div>
              </glxy-form-field>
            }
            <glxy-form-field horizontalLayout="true">
              <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.HEADING' | translate }}</glxy-label>
              <textarea
                #heading="ngModel"
                matInput
                type="text"
                name="heading-{{ i }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="8"
                autocomplete="off"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="item.heading"
                sharedContainsValidDynamicContent
              ></textarea>
              @if (heading.hasError('invalidDynamicComponent') && heading.touched) {
                <glxy-error>
                  {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
                </glxy-error>
              }
            </glxy-form-field>
            <glxy-form-field horizontalLayout="true">
              <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.SUBHEADING' | translate }}</glxy-label>
              <textarea
                #subheading="ngModel"
                matInput
                type="text"
                name="subheading-{{ i }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="8"
                autocomplete="off"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="item.subheading"
                sharedContainsValidDynamicContent
              ></textarea>
              @if (subheading.hasError('invalidDynamicComponent') && subheading.touched) {
                <glxy-error>
                  {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
                </glxy-error>
              }
            </glxy-form-field>
            <glxy-form-field horizontalLayout="true">
              <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.BODY_TEXT' | translate }}</glxy-label>
              <textarea
                #body="ngModel"
                matInput
                type="text"
                name="body-{{ i }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="8"
                autocomplete="off"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="item.body"
                sharedContainsValidDynamicContent
              ></textarea>
              @if (body.hasError('invalidDynamicComponent') && body.touched) {
                <glxy-error>
                  {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
                </glxy-error>
              }
            </glxy-form-field>
            <glxy-form-field horizontalLayout="true">
              <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LINK' | translate }}</glxy-label>
              <input
                matInput
                type="text"
                name="linkUrl-{{ i }}"
                autocomplete="off"
                placeholder="https://"
                [pattern]="urlMailtoOrDynamicContentRegex"
                [(ngModel)]="item.linkUrl"
                #linkUrl="ngModel"
              />
              @if (linkUrl.hasError('pattern') && linkUrl.touched) {
                <glxy-error>
                  {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.LINK' | translate }}
                </glxy-error>
              }
            </glxy-form-field>
            @if (item.linkUrl) {
              <glxy-form-field horizontalLayout="true">
                <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LINK_TEXT' | translate }}</glxy-label>
                <input
                  #linkText="ngModel"
                  matInput
                  type="text"
                  name="linkText-{{ i }}"
                  autocomplete="off"
                  placeholder="{{ 'EMAIL_BUILDER.IMAGE_AND_TEXT_BLOCK.LEARN_MORE' | translate }}"
                  [(ngModel)]="item.linkText"
                  sharedContainsValidDynamicContent
                />
                @if (linkText.hasError('invalidDynamicComponent') && linkText.touched) {
                  <glxy-error>
                    {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
                  </glxy-error>
                }
              </glxy-form-field>
            }
          </div>
        }
      </div>
    }
    <div class="drag-shield"></div>
  </div>

  <div class="add-item-button">
    <button type="button" mat-stroked-button (click)="addItem()">
      {{ content.layout === 'LargeVertical' ? 'Add column' : 'Add row' }}
    </button>
  </div>
</form>
